module.exports = __webpack_public_path__ + "img/bitmap.0909f17e.png";